<template>
  <div>
    <canvas :id="idCanva" class="w-100 my-auto"></canvas>
    <LoadingCover v-show="loading" />
  </div>
</template>
<script>
  import { uuid } from "vue-uuid";
  import { Chart, registerables } from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import { formatter } from "@/general";
  import CONSTANTS from "@/constants";
  import { dataCostoVentasKardex } from "@/apiData";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  Chart.register(...registerables)

  export default {
    name: "SalesParticipationCategoryChart",
    data() {
      return {
        uuid,
        formatter,
        loading: false,
        idCanva: "",
        colorsLabels: [
          CONSTANTS.colors.color01,
          CONSTANTS.colors.color02,
          CONSTANTS.colors.color03,
          CONSTANTS.colors.color04,
          CONSTANTS.colors.color05,
          CONSTANTS.colors.color06,
          CONSTANTS.colors.color07,
          CONSTANTS.colors.color08,
          CONSTANTS.colors.color09,
          CONSTANTS.colors.color10
        ],
        dataSalesParticipationCategory: []
      }
    },
    props: {
      title: String,
      initialDate: String,
      finalDate: String,
      reportType: String,
      utilityType: String,
      idCity: String,
      idBranch: String,
      idEmployeeGroup: String,
      idEmployee: String,
      idDirectory: String,
      idCategory: String,
      idBrand: String,
      valuesDivisor: Number,
      valuesSing: String
    },
    components: {
      LoadingCover
    },
    methods: {
      async getDataSalesParticipationCategory(){
        try {
          const { response } = await dataCostoVentasKardex(
            this,
            this.initialDate,
            this.finalDate,
            this.reportType,
            this.utilityType,
            this.idCity,
            this.idEmployeeGroup,
            this.idEmployee,
            this.idDirectory,
            this.idCategory,
            this.idBrand
          )

          this.dataSalesParticipationCategory = response
        } catch (error) {
          console.log(error)          
        }
      },
      setupChart() {
        let optionsChart = {
          responsive: true,
          maintainAspectRadio: false,
          interaction: {
              mode: "index",
              intersect: false
          },
          plugins: {
            title: {
              display: true,
              text: this.title
            },
            legend: {
              display: true,
              position: "top",
              labels: {
                boxWidth: 5,
                boxHeight: 5,
                font: {
                  size: 10
                }
              }
            },
            tooltip: {
              enabled: true,
              position: "nearest",
              usePointStyle: true,
              padding: 12,
              borderwidth: 1,
              backgroundColor: "midnightblue",
              callbacks: {
                label : function (context) {
                  return [context.label, "$" + context.formattedValue] + "M";
                }
              }
            },
            datalabels: {
              font: {
                size: 10
              },
              formatter: (value) => {
                let sum = 0
                this.dataSalesParticipationCategory.map(data => sum += (data.valor_Mercancia / this.valuesDivisor))
                let percentage = ((value * 100) / sum).toFixed(2)

                return `${percentage}%`
              }
            }
          }
        }

        const chart = new Chart(document.getElementById(this.idCanva), {
          type: "bar",
          data: {
            labels: this.dataSalesParticipationCategory.map(data => data.descripcion ? data.descripcion : "N/D"),
            datasets: [
              {
                type: "bar",
                label: "Ventas",
                data: this.dataSalesParticipationCategory.map(data => (data.valor_Mercancia / this.valuesDivisor)),
                fill: false,
                borderColor: this.colorsLabels.map(data => data),
                backgroundColor: this.colorsLabels.map(data => data)
              }
            ]
          },
          options: optionsChart,
          plugins: [ChartDataLabels]
        });

        chart.update();
      }
    },
    async mounted() {
      this.loading = true
      
      this.idCanva = uuid.v1()

      await this.getDataSalesParticipationCategory()
      this.setupChart()

      this.loading = false
    }
  }
</script>
